import { FiltersNumberMethod, FiltersRelativeDateMethod } from '../../utilities';

export class DashboardUtility {

    public static removeNullOrEmptyProperties<T extends Object = any>(input: T, relativeNumberFields: (keyof T)[] = [], relativeDateFields: (keyof T)[] = []) {

        if (!input) return input;

        const output = Object.keys(input).reduce((acc, key) => {

            const value = input[key];

            if (value !== null && value !== undefined) {

                if (Array.isArray(value) && value.length > 0) {
                    acc[key] = value;

                } else {
                    if ((relativeNumberFields as string[]).includes(key)) {
                        // check valid value for number relative picker
                        const fieldValue: FiltersNumberMethod = value;
                        if (fieldValue.operator && fieldValue.value) {
                            acc[key] = value;
                        }


                    } else if ((relativeDateFields as string[]).includes(key)) {
                        // check valid value for date relative picker
                        const fieldValue: FiltersRelativeDateMethod = value;
                        if (fieldValue.operator) {
                            acc[key] = value;
                        }
                    }
                }
            }

            return acc
        }, {})

        return output;
    }

    public static isCustomWidget(widgetTemplateId: string): boolean {
        if (!widgetTemplateId) return false;

        return widgetTemplateId.toLowerCase().endsWith('-custom');
    }

}